import React from 'react';

import { useCurrentUserQuery } from '@dashboard/generated/wp/authentication';
import { useEmailMessageQuery } from '@dashboard/generated/wp/platform';
import { Alert, Box, Stack, Typography } from '@mui/material';

import { DateFormatter } from '@waypoint/react-formatters';

import TriggerFailButton from './TriggerFailButton';
import TriggerSendButton from './TriggerSendButton';

type Props = {
  id: string;
};

function AdminActionsToolbar({ id }: Props) {
  const { data } = useEmailMessageQuery({ variables: { id } });
  const loading = data === undefined;
  if (loading) {
    return null;
  }
  const model = data.EmailMessage;
  if (model.status === 'SUCCEEDED') {
    return null;
  }

  return (
    <Alert variant="standard" severity="warning" sx={{ mb: 1 }}>
      <Typography variant="h6" gutterBottom>
        Administrator tools
      </Typography>
      <Box>
        <p>Status: {model.status}</p>
        <p>
          Created at: <DateFormatter template="full" value={model.createdAt} />
        </p>
        <Stack direction="row" spacing={1}>
          <TriggerSendButton emailMessage={model} />
          <TriggerFailButton emailMessage={model} />
        </Stack>
      </Box>
    </Alert>
  );
}

export default function AdministratorActions({ id }: Props) {
  const { data } = useCurrentUserQuery();
  const loading = data === undefined;

  if (loading) {
    return null;
  }

  if (!data.currentUser || data.currentUser.role !== 'ADMIN') {
    return null;
  }

  return <AdminActionsToolbar id={id} />;
}
